document.addEventListener('click', function(event) {
  const field = event.target.closest('.js-checkbox');
  if (!field) return;

  const checkbox = field.querySelector('input[type="checkbox"]');
  if (!checkbox) return;

  if (event.target !== checkbox) {
    checkbox.checked = !checkbox.checked;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

document.addEventListener('change', function(event) {
  const checkbox = event.target;
  if (!checkbox.matches('input[type="checkbox"]') || !checkbox.closest('.js-checkbox')) return;

  const attributeField = checkbox.closest('.cart-attribute__field');
  const noteContainer = attributeField ? attributeField.nextElementSibling : null;

  if (noteContainer) {
    const button = noteContainer.querySelector('.link-faded-reverse');

    if (button) {
      if (checkbox.checked) {
        button.setAttribute('aria-expanded', 'true');

        const controlsId = button.getAttribute('aria-controls');
        if (controlsId) {
          const dialog = document.getElementById(controlsId);

          if (dialog) {
            dialog.setAttribute('open', '');
            dialog.style.display = 'block';
            dialog.style.transform = 'translateY(0px)';
          }
        }
      } else {
        button.setAttribute('aria-expanded', 'false');
      }
    }
  }
});